import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { APIList } from 'src/interfaces'
import { Entities } from 'src/enums'
import { Label } from 'src/api'
import { useApiInstance } from './useApiInstance'
import {
  buildRequestParams,
  ObjectType,
  transformPage,
  transformPerPage,
} from './helpers'

interface RequestParams {
  params?: Partial<LabelGetParams>;
  paramsTransform?: Array<(params: Record<string, any>) => Record<string, any>>;
  options?: Omit<
    UseQueryOptions<unknown, Error, APIList<Label>>,
    'queryKey' | 'queryFn'
  >;
}

interface LabelGetParams {
  sort: string;
}

const schema: ObjectType['schema'] = {
  sort: 'string',
}

export const useLabelListRequest = ({
  params = {},
  paramsTransform = [],
  options,
}: RequestParams = {}) => {
  const api = useApiInstance()

  const transformedParams = [
    transformPerPage,
    transformPage,
    ...paramsTransform,
  ].reduce((param, transform) => transform(param), params)

  const queryParams = buildRequestParams<LabelGetParams>(
    transformedParams,
    schema,
  )

  return useQuery<unknown, Error, APIList<Label>>(
    [Entities.Label, JSON.stringify(transformedParams)],
    async () => {
      const { sort } = queryParams
      const { data } = await api.v1AdminLabelsGet(sort)
      return data
    },
    options,
  )
}
